export default "/_next/static/fonts/tt_norms_pro_demibold_italic-7f944ae5ad0f1342543e8f148cdb3b12.woff";